// @ts-nocheck
import { Fragment, useEffect, useRef, useState, useCallback, useMemo } from "react";
// import { Canvas, useFrame, RootState } from "@react-three/fiber";
// import { Splat, OrbitControls, Line } from "@react-three/drei";
import { useHexagonSize } from "src/hooks/useHexagonSize";

import { interpolateVector3Array } from "src/utils/navigation";
import { useModelViewerStore } from "@/store/modelViewerStore";

import {
  Vector3Point,
  Point3D,
  filterStraightLinePoints,
} from "src/utils/three";
// import * as THREE from "three";

// import {
//   getVenueModelConfig,
//   getAltitude,
//   VenueModelConfig,
// } from "@/const/venue_model/venue_model_config";

import {
  getVenueModelConfigByVenueCode,
  getAltitudeByFloorName,
  VenueModelConfig,
  getBaseUrl,
  getVenueIdByVenueCode,
  getAllFloorMapAlignByVenueId,
  getMapSettingByVenueCode,
  getFloorSizeByFloorIndex,
} from "src/utils/map-util";

import * as pc from "playcanvas";
import {
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  interpolateVector3,
} from "src/utils/game";
import { OrbitControls } from "@playcanvas/react/scripts";
import { useMaterial, useAppEvent } from "@playcanvas/react/hooks";
import { Application, Entity } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  Environment,
} from "@playcanvas/react/components";
import { useEnvAtlas } from "@playcanvas/react/hooks";
import { GSplat, Script } from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";
import {
  useTexture,
  useApp,
  useSplat,
  useModel,
} from "@playcanvas/react/hooks";
import { Gltf } from "@playcanvas/react";

export default function ModelViewerTopView() {
  const latestProgressRef = useRef<number>(0);

  const latestNavigationPositionArrayRef = useRef<pc.Vec3[]>([]);
  const latestCameraPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestCameraLookingPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const { HEX_WIDTH_INNER, HEX_HEIGHT_INNER } = useHexagonSize();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 769);
    };

    checkIsMobile(); // Check on initial render
    window.addEventListener("resize", checkIsMobile);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const topViewModelAllRef = useRef({});

  function useQueryParams() {
    return useMemo(() => new URLSearchParams(window.location.search), []);
  }

  const DataController = () => {
    const cameraPosition = useModelViewerStore((state) => state.cameraPosition);
    const cameraLookingPosition = useModelViewerStore(
      (state) => state.cameraLookingPosition,
    );
    useEffect(() => {
      latestCameraPositionRef.current = cameraPosition;
      latestCameraLookingPositionRef.current = cameraLookingPosition;

      console.log(latestCameraPositionRef.current);
    }, [cameraPosition, cameraLookingPosition]);
    return <></>;
  };

  const MainObject = () => {
    const app = useApp();
    const mainObjectEntityRef = useRef();
    const cameraScriptRef = useRef();
    const cameraRef = useRef();
    let _localProgress;
    let finalCameraPosition = new pc.Vec3(0, 0, 0);
    let finalCameraLookingPosition = new pc.Vec3(0, 0, 0);

    let _localCameraPosition;

    let lastUpdate = 0;
    const UPDATE_INTERVAL = 1 / 10;
    const handleUpdate = useCallback((dt: number) => {
      lastUpdate += dt;
      if (lastUpdate >= UPDATE_INTERVAL) {
        updateFrame();
        lastUpdate = 0;
      }
    }, []);
    const updateFrame = () => {
      if (!cameraScriptRef.current) {
        return;
      }

      let isCameraPositionUpdated =
        _localCameraPosition != latestCameraPositionRef.current;
      _localCameraPosition = latestCameraPositionRef.current;

      finalCameraPosition = new pc.Vec3(
        _localCameraPosition.x,
        _localCameraPosition.y + 50,
        _localCameraPosition.z,
      );

      finalCameraLookingPosition = new pc.Vec3(
        _localCameraPosition.x,
        _localCameraPosition.y,
        _localCameraPosition.z - 0.001,
      );

      cameraScriptRef.current.reset(
        finalCameraLookingPosition,
        finalCameraPosition,
      );
    };
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      // cameraScriptRef.current.reset(
      //   defaultCameraLookingPosition,
      //   defaultPosition,
      // );
    }, []);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity>
          <Camera clearColor="#000000" />
          <Script
            ref={cameraScriptRef}
            script={CameraControls}
            enableFly={false}
          />
        </Entity>
      </Entity>
    );
  };

  const ModelPly = () => {
    const queryParams = useQueryParams();
    const modelLink = queryParams.get("model");
    const model_no_ceiling = modelLink.replace(".sog", "_no_ceiling.sog");
    const app = useApp();
    const gsplatRef = useRef();
    const { asset, error } = useSplat(model_no_ceiling);
    if (error) {
      console.error("Splat load error:", error);
    }
    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatRef.current;
      if (!gsplatRef.current || !app) return;
      gsplatRef.current.gsplat.enabled = true;
      gsplatRef.current.gsplat.unified = true;
      gsplatRef.current.gsplat.asset = asset;
    }, [asset]);

    return (
      <Entity
        ref={gsplatRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[1 / 1 / 1]}
      >
        <GSplat />
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        <Environment exposure={1.0} luminance={0.4} />
        <MainObject />
        <ModelPly />
      </>
    );
  };

  const TopDownScene = () => {
    return (
      <Application
        usePhysics={false}
        maxDeltaTime={0.033}
        timeScale={1.0}
        graphicsDeviceOptions={{
          powerPreference: "low-power",
          alpha: false,
          antialias: false,
          preferWebGl2: true,
          stencil: false,
        }}
      >
        <PlaycanvasScene />
      </Application>
    );
  };

  const DirectionLight = () => {
    const cameraAngle = useModelViewerStore((state) => state.cameraAngle);
    return (
      <div
        className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
        style={{ transform: `rotate(${cameraAngle + 180}deg)` }}
      >
        {/*<div className="fixed w-[60px] h-[50px] left-1/2 -translate-x-1/2 -translate-y-full bg-gradient-to-t from-[#FFFFFFDD] to-[#FFFFFF00] [clip-path:polygon(0_0,100%_0,60%_100%,40%_100%)]"></div>*/}
        <div className="fixed w-[80px] left-1/2 -translate-x-1/2 -translate-y-full">
          <img
            src="/assets/spotlight.png"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    );
  };

  const LogoDot = () => {
    const cameraAngle = useModelViewerStore((state) => state.cameraAngle);
    return (
      <div style={{ transform: `rotate(${cameraAngle + 180}deg)` }}>
        <img
          src="/assets/icon_logo_dot.png"
          className="w-full h-full object-cover"
        />
      </div>
    );
  };

  return (
    <div
      id="navi-top-view-parent"
      className={`relative hex-crop ${isMobile ? "mobile" : "desktop"} pointer-events-none`}
      style={{
        width: `${HEX_WIDTH_INNER}px`,
        height: `${HEX_HEIGHT_INNER}px`,
      }}
    >
      <div
        className={`relative left-0 bottom-0 h-[100%] w-[100%] transform rotate-180 overflow-hidden`}
      >
        <div
          className={`absolute h-[100%] w-[100%] overflow-hidden bg-black`}
        />

        <div
          id="div-above-canvas"
          className="absolute left-0 bottom-0"
          style={{
            width: `${HEX_WIDTH_INNER}px`,
            height: `${HEX_HEIGHT_INNER}px`,
          }}
        >
          <DataController />
          <TopDownScene />
        </div>

        <div className="absolute top-1/2 left-1/2 w-[20px] h-[20px] -translate-x-1/2 -translate-y-1/2">
          <DirectionLight />
          <LogoDot />
        </div>
      </div>
    </div>
  );
}
